import { FC } from "react";
import { Modal } from "@components/modal";
import { Panel, PanelHeader, PanelTitleArea, PanelTitle, PanelBody } from "@components/panel";
import { ImageEditor } from "./image-editor";
import { CropType, FileUploaded } from "@archetypes/generic";
import { UploadMediaType } from "@archetypes/app";

interface EditImageDialogProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  onFileUploaded: (file: FileUploaded) => void;
  filePath?: string;
  fileName?: string;
  cropType?: CropType;
  fileType: UploadMediaType;
  maxSize?: number;
}

export const EditImageDialog: FC<EditImageDialogProps> = ({
  isOpen,
  onClose,
  onFileUploaded,
  filePath,
  fileName,
  title,
  cropType,
  fileType,
  maxSize,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} placement="middle">
      <Panel>
        <PanelHeader>
          <PanelTitleArea>
            <PanelTitle>{title}</PanelTitle>
          </PanelTitleArea>
        </PanelHeader>
        <PanelBody>
          <ImageEditor
            filePath={filePath}
            fileName={fileName}
            onFileUploaded={onFileUploaded}
            cropType={cropType}
            onClose={onClose}
            maxSize={maxSize}
            fileType={fileType}
          />
        </PanelBody>
      </Panel>
    </Modal>
  );
};
